import { render, staticRenderFns } from "./industry.vue?vue&type=template&id=452c2b01&scoped=true"
import script from "./industry.vue?vue&type=script&lang=js"
export * from "./industry.vue?vue&type=script&lang=js"
import style0 from "./industry.vue?vue&type=style&index=0&id=452c2b01&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c2b01",
  null
  
)

export default component.exports